<div cdkOverlayOrigin #trigger="cdkOverlayOrigin">
    <div class="head" [ngClass]="selectedOption?.class" [class.simple-view]="dataFilterConfig?.simpleView" *ngIf="!isSiteDropdown">
        <input
            type="text"
            name="filter"
            readonly
            #inputControl
            [ngClass]="{ 'opened': isOpened }"
            [(ngModel)]="valueText"
            [disabled]="isDisabled"
            [placeholder]="placeholderText"
            (focus)="onFocus(); inputFocused.emit(true)"
            (blur)="inputFocused.emit(false)"
            (click)="toggleState()">

        <div class="value-text"
            *ngIf="dataFilterConfig?.simpleView"
            (click)="toggleState()"
            (keydown.enter)="toggleState()"
            tabindex="0"
            role="button"> {{ valueText }}
            <i class="icon-ic_expand_arrow" [class.inverted]="isOpened"></i>
        </div>
    </div>

    <div *ngIf="isSiteDropdown"
        (click)="toggleState()"
        (keydown.enter)="toggleState()"
        tabindex="0"
        role="button"
        class="sites-dropdown-header"
        [class.active]="this.isOpened"
        #inputControl>
        <span>{{ placeholderText }}: </span> {{ showDropdownTitle() }}
        <i class="icon-ic_dropdown_arrow"></i>
    </div>
</div>

<ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpened"
    [cdkConnectedOverlayWidth]="optionsWidth"
    [cdkConnectedOverlayFlexibleDimensions]="true"
    [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
>
    <div class="options-list"
        [class.filter-mode]="dataFilterConfig"
        [class.multi]="dataFilterConfig?.type === 'multi'">
        <ng-container *ngIf="!dataFilterConfig; else templateWithFilter" >
            <!-- options list -->
            <ul>
                <li class="option"
                    *ngIf="allowResetControl"
                    (click)="optionOnClick({ keyName: null })"
                    (keydown.enter)="optionOnClick({ keyName: null })"
                    tabindex="0"
                    role="button">
                    Not selected
                </li>
                <li *ngFor="let option of optionsList; let ind = index;"
                    appEllipsisTooltip
                    (click)="optionOnClick(option)"
                    (keydown.enter)="optionOnClick(option)"
                    tabindex="0"
                    role="button"
                    [ngClass]="{
                        'disabled': option.disabled,
                        'selected': option.selected
                    }"
                    class="option {{option.class}}">
                    {{ option[dropdownValueName || valueName] }}
                </li>
            </ul>

            <!-- no data message -->
            <div *ngIf="!optionsList.length" class="no-data-msg">{{ noDataText }}</div>
        </ng-container>
    </div>
</ng-template>

<ng-template #templateWithFilter>
    <ng-container [ngSwitch]="dataFilterConfig.type">
        <ng-template ngSwitchCase="simple">
            <ng-container *ngTemplateOutlet="templateSimple"></ng-container>
        </ng-template>
    </ng-container>
</ng-template>

<ng-template #templateSimple>
    <div class="dropdown-search" *ngIf="optionsList.length > dropdownConfig?.filterLimit">
        <input [(ngModel)]="filterQuery"
               type="search" [placeholder]="dataFilterConfig.placeholder || 'Search'"
               (focus)="$event.stopPropagation()"
               (click)="$event.stopPropagation()">
        <i class="icon-search search-icon"></i>
        <i *ngIf="filterQuery" class="icon-cross_16px clear-control" (click)="$event.stopPropagation(); filterQuery=''" (keydown.enter)="$event.stopPropagation(); filterQuery=''" tabindex="0" role="button"></i>
    </div>

    <!-- options list -->
    <ul *ngIf="optionsList && (optionsList | filterBy: filterQuery: dataFilterConfig.filterField: dataFilterConfig.strictFiltering).length;
        else noFilteredResults">
        <li class="option"
            *ngIf="allowResetControl"
            (click)="optionOnClick({ keyName: null })"
            (keydown.enter)="optionOnClick({ keyName: null })"
            tabindex="0"
            role="button">
            Not selected
        </li>
        <li *ngFor="let option of optionsList | filterBy: filterQuery: dataFilterConfig.filterField: dataFilterConfig.strictFiltering;
            let ind = index;"
            appEllipsisTooltip
            (click)="optionOnClick(option); filterQuery=''"
            (keydown.enter)="optionOnClick(option); filterQuery=''"
            tabindex="0"
            role="button"
            [ngClass]="{
                'disabled': option.disabled,
                'selected': option.selected
            }"
            class="option {{option.class}}"
            [id]="option[keyName]"
            [innerHTML]="option[dropdownValueName || valueName]
                | htmltransfrom | highlight: filterQuery : dataFilterConfig.minHighlightLength">
        </li>
    </ul>
</ng-template>

<ng-template #noFilteredResults>
    <div class="no-data-msg">{{ dataFilterConfig.noDataText }}</div>
</ng-template>
